import { useTranslation } from 'react-i18next';

interface KeyOutcomesCardProps {
  outcomes: readonly string[];
}

/**
 * "Key outcomes" — bordered card. Always expanded; no expand/collapse
 * interaction and no decorative icons (just label + hairline + bullet list).
 *
 * Figma carryover:
 *   - Card: `border border-clearlab-divider-darker rounded-lg p-[24px]`
 *   - "Key outcomes" label: Karla Regular 16/18 clearlab-midnight
 *   - 0.7px hairline `border-clearlab-divider-darker` below the label
 *   - <ul list-disc>: each <li> with `ms-6 mb-5` (last item no mb), inner
 *     <span class="leading-7"> per item.
 */
export function KeyOutcomesCard({ outcomes }: KeyOutcomesCardProps) {
  const { t } = useTranslation();
  return (
    <div className="flex w-full flex-col items-start gap-4 rounded-lg border border-clearlab-divider-darker p-6">
      <p className="text-[16px] font-normal leading-[18px] text-clearlab-midnight">
        {t('technology.keyOutcomesHeading')}
      </p>

      <hr className="w-full border-0 border-t-[0.7px] border-clearlab-divider-darker" />

      <ul className="block w-full list-disc text-[16px] font-normal text-clearlab-midnight">
        {outcomes.map((outcome, idx) => (
          <li key={outcome} className={idx < outcomes.length - 1 ? 'mb-5 ms-6' : 'ms-6'}>
            <span className="leading-7">{outcome}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
